export const portfolioItemIdTypes = {
  SCOPEONE_ID: 'scopeoneIdentifier',
  ESG_ID: 'esgId',
  ARTIFACT_ID: 'artifactId',
};
